import styled from 'styled-components';

export const CustomButton = styled.div`
	&:hover {
		span {
			color: white;
		}
	}
`;
